import { useTheme } from "@emotion/react";
import { FormHelperText } from "@mui/material";

export default function ErrorMSG({ text }) {
  const { palette } = useTheme();

  return <FormHelperText sx={{ color: palette.danger.main, marginLeft: 0 }}>{text}</FormHelperText>;
}
